import genEnum from '../services/genEnum';

export const YesNoUnknown = genEnum( // eslint-disable-line import/prefer-default-export
  'YES',
  'NO',
  'UNKNOWN'
);
